import apiClient from "../../../api-client";
import getWrappedUseMutation from "../../helpers/getWrappedUseMutation";

export const useUpdateGdprRequestMutation = getWrappedUseMutation(apiClient.GdprRequests.put);
